import { render } from "./HzbaModalItemBlock.vue?vue&type=template&id=046a1c39&scoped=true"
import script from "./HzbaModalItemBlock.vue?vue&type=script&lang=js"
export * from "./HzbaModalItemBlock.vue?vue&type=script&lang=js"

import "./HzbaModalItemBlock.vue?vue&type=style&index=0&id=046a1c39&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046a1c39"]])

export default __exports__